import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './app/App';
import reportWebVitals from './reportWebVitals';
import { createBrowserRouter, RouterProvider } from 'react-router';
import { store } from './app/store';
import { Provider } from 'react-redux';
import HomePage from './components/homePage/HomePage';
import About from './components/about/About';
import ContactPage from './components/contactPage/ContactPage';
import ShopPage from './features/shopPage/ShopPage';
import ShippingForm from './features/shippingForm/ShippingForm';
import ConfirmationPage from './components/confirmationPage/ConfirmationPage';

const root = ReactDOM.createRoot(document.getElementById('root'));

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        path: "",
        element: <HomePage />
      },
      {
        path: "/about",
        element: <About />
      },
      {
        path: "/contact",
        element: <ContactPage />
      },
      {
        path: '/shop',
        element: <ShopPage />
      },
      {
        path: '/shipping',
        element: <ShippingForm />
      },
      {
        path: '/confirmation',
        element: <ConfirmationPage />
      }
    ]
  }
])
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <RouterProvider router={router} />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
